module.exports = "/next-static/_next/static/images/hero_image_large-1a07c944ff2d94b93634691d918aeef4.png";